// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"Header_mainHeading__17XTl","text":"Header_text__2_03t","textFirst":"Header_textFirst__1JiEt"};